import { render, staticRenderFns } from "./data-loader.vue?vue&type=template&id=250d1111"
import script from "./data-loader.vue?vue&type=script&lang=js"
export * from "./data-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports